import {SortDirection} from 'src/openapi/admin/models/SortDirection';

import {GRANT_STATUS_CAPTIONS} from '../constants';

import type {ResourceView} from '../typedef';
import type {EntitlementResource} from 'src/openapi/admin/models/EntitlementResource';
import type {Grant} from 'src/openapi/admin/models/Grant';
import type {PresetRelationItem} from 'src/openapi/admin/models/PresetRelationItem';
import type {Role} from 'src/openapi/admin/models/Role';


type GetEntitlementListProps = {
    relations: PresetRelationItem[],
    resources: Record<string, EntitlementResource>,
    roles: Record<string, Role>,
    grants: Record<string, Grant>,

    sortDirection: SortDirection,
};
export type GetEntitlementList = (props: GetEntitlementListProps) => ResourceView[];

export const getPresetEntitlementList: GetEntitlementList = ({
    roles,
    grants,
    resources,
    relations,
    sortDirection,
}) => {
    const view: ResourceView[] = [];
    const assignedResources: Record<string, ResourceView[]> = {};
    const freeResources: ResourceView[] = [];

    relations.forEach(({resourceId, grantId, roleId, level}) => {
        const resourceView: ResourceView = {
            recordId: '',

            title: resources[resourceId]?.name,
            description: resources[resourceId]?.description,
            level,

            grantTitle: grants[grantId]?.name,
            statusTitle: GRANT_STATUS_CAPTIONS[grants[grantId]?.status],
            restrictionTitle: grants[grantId]?.daysToDelay !== null
                ? `DaysToDelay: ${grants[grantId]?.daysToDelay}`
                : '--',
        };

        if (!roleId) {
            freeResources.push({...resourceView, recordId: JSON.stringify({resourceId, grantId})});
        } else if (!assignedResources[roleId]) {
            assignedResources[roleId] = [];
            assignedResources[roleId].push({
                ...resourceView,
                recordId: JSON.stringify({resourceId, grantId, roleId}),
            });
        } else {
            assignedResources[roleId].push({
                ...resourceView,
                recordId: JSON.stringify({resourceId, grantId, roleId}),
            });
        }
    });

    const sortFunc = (a: string, b: string) => {
        if (!a || !b) {
            return 0;
        }
        return sortDirection === SortDirection.ASC ? a.localeCompare(b) : b.localeCompare(a);
    };

    Object
        .keys(roles)
        .sort((a, b) => sortFunc(roles[a].name, roles[b].name))
        .forEach(roleId => {
            const assignedResourceViews = assignedResources[roleId];
            const level = relations.find(({roleId: id}) => id === roleId)?.level;

            if (assignedResourceViews) {
                view.push({
                    recordId: JSON.stringify({roleId}),
                    title: `${roles[roleId]?.name} (${assignedResourceViews.length})`,
                    description: roles[roleId]?.description,
                    level,
                });

                view.push(...assignedResourceViews
                    .sort((a, b) => sortFunc(a.title, b.title)),
                );
            }
        });

    view.push(...freeResources.sort((a, b) => sortFunc(a.title, b.title)));

    return view;
};
